import { z } from "zod";
import { BusinessUnitItemSchema } from "./business-unit-item";
import { ResultDataSchema } from "../result-data/result-data";

export const BusinessUnitResultSchema = ResultDataSchema.extend({
  Results: BusinessUnitItemSchema.array(),
});

export type BusinessUnitResultType = z.infer<typeof BusinessUnitResultSchema>;
